import router from '@/router'
import config from '@/constant/config'
import store from '@/store'

import { getVipCount } from '@/http/api/getApi'
import { productData } from '@/constant/productData'

//时间戳转时间
const timestampToTime = (timestamp) => {
	if (!timestamp) return ""
	return timestamp.substr(0, 19).replace('T', ' ');
}

// 判断前后是否含有""
const isQuoted = (str) => {
	return str.startsWith('"') && str.endsWith('"');
}

// 判断设备是否为移动端
const isMobile = () => {
	return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
		.test(
			navigator.userAgent
		);
};

// 跳转到新的项目
const openProduct = (product) => {
	let url = ''
	if (product.routeName) { // 本项目内
		try {
		  const { href } = router.resolve({
		  	name: product.routeName
		  })
		  url = window.location.origin + href;
		  window.open(url, '_blank', 'noopener,noreferrer');
		} catch (error) {
		  console.error(`路由解析失败：未找到名为 ${product.routeName} 的路由`);
		}
		return
	}
	
	if (product.link) { // 外部链接
		url = `${product.link}`
		window.open(url, '_blank', 'noopener,noreferrer');
		return
	}
}

const getVipData = () => {
	return getVipCount().then(res => res.data).catch(() => {})
}

// 节流函数
const throttle = (fn, delay = 200) => {
	let lastTime = 0
	return function(...args) {
		const now = Date.now()
		if (now - lastTime >= delay) {
			lastTime = now
			fn.apply(this, args)
		}
	}
}

// 跳转登录页
const goLogin = () => {
	const returnUrl = `${window.location.origin}/#/home`
	window.location.href = `${config.USER_BASE_URL}/user/ssologin?sid=${config.itemSid}&returnUrl=${encodeURIComponent(returnUrl)}`
}

// 统一登录检查方法
// Vue组件中调用: this.$common.checkLogin(callback)
const checkLogin = (vueInstance, callback) => {
	let userInfo = store.state.userInfo

	if (!userInfo || !userInfo.userId) {
		goLogin()
		return false
	}
	if (callback) callback()
	return true
}

// 根据产品 id 或 appId 获取产品数据  $common.getProductById(appId, "appId")
// @param {number|string} key - 产品 id 或 appId
// @param {string} type - 查找类型，'id' 或 'appId'，默认 'id'
// @returns {object|null} - 产品数据对象，未找到返回 null
const getProductById = (key, type = 'id') => {
	for (const module of productData) {
		const product = module.childer.find(p => p[type] === key)
		if (product) {
			return product
		}
	}
	return null
}

// 获取产品的vip数据（只使用单位会员权限）
const getVipProduct = (key, type = 'appId') => {
	const userInfo = store.state.userInfo || {}
	const vipUnitProducts = userInfo.vipUnitProducts || []

	return vipUnitProducts.find(vip => vip[type] === key && vip.status == 1) || null
}

// 小数点两个数相减
const accurateSubtraction = (num1, num2) => {
	if(!num1 || !num2) return false
  // 简单处理：找到两个数中小数点后最长的位数
  const len1 = (num1.toString().split('.')[1] || '').length;
  const len2 = (num2.toString().split('.')[1] || '').length;
  const maxLen = Math.max(len1, len2);
  
  // 放大倍数
  const multiplier = Math.pow(10, maxLen);
  
  // 变成整数相减，再除以倍数还原
  return (Math.round(num1 * multiplier) - Math.round(num2 * multiplier)) / multiplier;
}

// JSON 对象转标准 Base64
const jsonToUrlSafeBase64 = (jsonObj) => {
  try {
    // 1. 将 JSON 对象序列化为字符串
    const jsonString = JSON.stringify(jsonObj);
    
    // 2. 使用 TextEncoder 将字符串转换为 UTF-8 字节数组（完美支持中文及特殊字符）
    const utf8Bytes = new TextEncoder().encode(jsonString);
    
    // 3. 将字节数组转换为二进制字符串，以便 btoa 处理
    let binaryString = '';
    for (let i = 0; i < utf8Bytes.length; i++) {
      binaryString += String.fromCharCode(utf8Bytes[i]);
    }
    
    // 4. 转换为标准 Base64，并替换为 URL 安全字符，移除末尾的 '='
    return btoa(binaryString)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
      
  } catch (error) {
    console.error('JSON 转 Base64URL 失败:', error);
    return null;
  }
}

// 判断时间是否满足几天
// console.log(isOverDays('2026-06-27T10:23:45', 30));
const isOverDays = (targetTimeStr, day) => {
  const targetDate = new Date(targetTimeStr);
  const now = new Date();
  
  // 防止传入无效时间
  if (isNaN(targetDate.getTime())) {
    throw new Error("无效的时间格式");
  }

  const thirtyDaysInMs = day * 24 * 60 * 60 * 1000;
  const diffInMs = now.getTime() - targetDate.getTime();

  return diffInMs >= thirtyDaysInMs;
}

export default {
	timestampToTime,
	isQuoted,
	isMobile,
	openProduct,
	getVipData,
	throttle,
	goLogin,
	checkLogin,
	getProductById,
	getVipProduct,
	accurateSubtraction,
	jsonToUrlSafeBase64,
	isOverDays
}